<template>
  <div :id="domId"></div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';

export default {
  name: "Map",
  data(){
    return{
      map: null,
      domId: null
    }
  },
  created() {
    this.domId = new Date().getTime();
  },
  mounted(){
    //DOM初始化完成进行地图初始化
    this.initMap();
  },
  methods:{
    initMap(){
      AMapLoader.load({
        key:"21982024e1384ee8584ce871582988cf",             // 申请好的Web端开发者Key，首次调用 load 时必填
        version:"2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins:[''],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap)=>{
        this.map = new AMap.Map(this.domId,{  //设置地图容器id
          viewMode:"3D",    //是否为3D地图模式
          zoom:5,           //初始化地图级别
          center:[105.602725,37.076636], //初始化地图中心点位置
        });
      }).catch(e=>{
        console.log(e);
      })
    },
  },
}
</script>

<style  scoped>
#container{
  padding:0px;
  margin: 0px;
  width: 100%;
  height: 100%;
  border-radius: 16px;
}
</style>
